import { gql, useQuery } from '@apollo/client';
import type { ProductVehicle } from '../../types';
import type { MotorcycleSearchParams } from '../../components/MotorcycleSearch';
import { ccmValuesFromRange } from '../../util/getCcmFilterValues';

const useVehicles = ({
    search,
    model,
    make,
    ccm,
    type,
    typeApprovalList,
    pageSize,
    page,
}: MotorcycleSearchParams) => {
    const { ccmRangeStart, ccmRangeEnd } = ccmValuesFromRange(ccm);

    const {
        data: { vehicles } = { vehicles: { items: [], total: 0 } },
        loading,
        error,
    } = useQuery<{
        vehicles: {
            items: ProductVehicle[];
            total: number;
        };
    }>(
        gql`
            query vehicles(
                $search: String
                $manufacturerName: [String!]
                $model: [String!]
                $ratedPower: [String!]
                $typeNumbers: [String!]
                $typeAcceptanceList: [String!]
                $ccmRangeStart: Int
                $ccmRangeEnd: Int
                $limit: Int
                $offset: Int
            ) {
                vehicles: motorcycles(
                    search: $search
                    manufacturerName: $manufacturerName
                    model: $model
                    ratedPower: $ratedPower
                    typeNumbers: $typeNumbers
                    typeAcceptanceList: $typeAcceptanceList
                    ccmRangeStart: $ccmRangeStart
                    ccmRangeEnd: $ccmRangeEnd
                    limit: $limit
                    offset: $offset
                ) {
                    items {
                        id
                        model
                        manufacturerName
                        ccm
                        ratedPower
                        typeNumbers
                        typeAcceptanceList
                        manufacturingStartYear
                        manufacturingEndYear
                    }
                    total
                }
            }
        `,
        {
            fetchPolicy: 'cache-first',
            variables: {
                search,
                model,
                manufacturerName: make,
                ccmRangeStart,
                ccmRangeEnd,
                typeNumbers: type,
                typeAcceptanceList: typeApprovalList,
                limit: pageSize,
                offset: (page - 1) * pageSize,
            },
        }
    );

    return {
        vehicles: vehicles.items,
        total: vehicles.total,
        loading,
        error,
    };
};

export default useVehicles;
